<template>
  <div class="box">
    <div class="row">
      <div class="col-md-12 m-3">
        <h3>Accounts</h3>
      </div>
    </div>
    <hr/>
    <div class="row">
      <div class="col-md-12">
        <div class="wrap">
          <dl class="summary">
    
            <dt>Total invoice value</dt>
            <dd>
              <template v-if="booking.cancelled_at">
                <del>
                  {{ booking.total_due | formatCurrency }}
                </del>
                &nbsp;
                <template v-if="(Number(booking.cancellation_charge) > 0)">
                  {{ Number(booking.cancellation_charge) | formatCurrency }}
                </template>
                <template v-else>
                  0.00
                </template>
              </template>
              <template v-else>
                {{ booking.total_due | formatCurrency }}
              </template>
            </dd>
            <dt>Total receipts</dt>
              <dd>{{ totalReceipt | formatCurrency }}</dd>
            <dt>Balance outstanding</dt>
              <dd>{{ balanceOutstanding | formatCurrency }}</dd>
            <dt>Due by</dt>
            <dd class="form form--inline">
              <input type="date" v-model="booking.balance_due">
              <button class="button button--small" v-on:click="$emit('update-booking')">
                Update
              </button>
            </dd>
          
            <template v-if="booking.old_tour_booking !== null">
              <dt>New system total</dt>
              <dd>{{ totalDue | formatCurrency }}</dd>
            </template>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BookingAccounts',
  props : {
    booking: Object,
    totalDue: Number
  },
  computed: {
    balanceOutstanding() {
      if (this.booking.cancelled_at) {
        if (Number(this.booking.cancellation_charge) == 0) {
          return Number(this.booking.total_due) - Number(this.booking.paid);
        }else {
          return Number(this.booking.cancellation_charge) - Number(this.booking.paid)
        }
      } else {
        return this.booking.balance
      }
    },
    totalReceipt() {
      // if (this.booking.cancelled_at) {

      //   if (Number(this.booking.cancellation_charge) == 0) {
      //     return this.booking.paid
      //   }

      //   if (this.booking.paid >= this.booking.cancellation_charge) {
      //     return Number(this.booking.cancellation_charge)
      //   } else {
      //     return Number(this.booking.cancellation_charge) - Number(this.booking.paid)
      //   }

      // } else {
        return Number(this.booking.paid)
      // }
    }
  }
}
</script>

